function download(name) {
    const anchor = document.createElement('a')
    anchor.href = `${process.env.BASE_URL}${name}`
    anchor.setAttribute('download', name)
    anchor.innerHTML = 'downloading...'
    anchor.style.display = 'none'
    document.body.appendChild(anchor)
    setTimeout(() => {
        anchor.click()
        document.body.removeChild(anchor)
        setTimeout(() => { self.URL.revokeObjectURL(anchor.href) }, 250)
    }, 66)
}
// 使用iframe框架下载文件--以excel为例，可修改type与fileName选择文件类型
function exportExcel(res, name) {
    var tag = changeType(name
        .substring(name.lastIndexOf(".") + 1)
        .toLowerCase());
    if (window.navigator.msSaveBlob) {
        try {
            const blobObject = new Blob([res], { type: tag })
            window.navigator.msSaveBlob(blobObject, `${name}`);
        } catch (e) {
            console.log(e);
        }
    } else {
        const blob = new Blob([res], { type: tag }) // 构造一个blob对象来处理数据
        // const blob = new Blob([res], { type: 'application/x-excel' }) // 构造一个blob对象来处理数据
        const elink = document.createElement('a') // 创建a标签
        elink.style.display = 'none'
        elink.href = URL.createObjectURL(blob)
        elink.download = decodeURIComponent(name)
        document.body.appendChild(elink)
        elink.click() // 执行下载
        URL.revokeObjectURL(elink.href) // 释放URL 对象
        document.body.removeChild(elink) // 释放标签
    }
}
function changeType(type) {
    if (type == "xls" || type == "xlsx") {
        return "application/vnd.ms-excel"
    } else if (type == "zip") {
        return "application/zip"
    } else if (type == "pdf") {
        return "application/pdf"
    } else if (type == "doc" || type == "docx") {
        return "application/msword"
    } else if (type == "ppt" || type == "pptx") {
        return "application/vnd.ms-powerpoint"
    } else if (type == "txt") {
        return "text/plain"
    } else if (type == "png") {
        return "image/png"
    } else if (type == "jpg" || type == "jpeg") {
        return "image/jpeg"
    }
}
export {
    download,
    exportExcel
}
